import {withStyles} from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";

export const StrippedTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: "var(--container-primary)"
        }
    }
}))(TableRow);